/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect, Fragment} from 'react'
import {useIntl} from 'react-intl'
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import {PageTitle} from '../../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import {Col, Dropdown, Modal, Row, Spinner} from 'react-bootstrap'
import Pagination from 'react-bootstrap/Pagination'
import usePagination from 'utils/hooks/usePagination'
import {useNavigate} from 'react-router-dom'
import JobServices from '../../../../services/job'
import useServices from '../../../../utils/hooks/useServices'
import useDebounce from '../../../../utils/hooks/useDebounce'
import MasterServices from '../../../../services/master'
import {toast} from 'react-toastify'
import FormGenerator from '../../../../utils/helpers/FormGenerator'

let active = 1
let items: any = []
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>
  )
}

const heads = [
  {
    name: '',
    label: 'Nama Role',
  },
  {
    name: '',
    label: 'Status',
  },
  {
    name: '',
    label: 'Aksi',
  },
]

const inputs = [
  {
    name: 'name',
    label: 'Nama Role',
    type: '',
    validation: {},
    col: 12,
    options: [],
    additional: '',
  },
  {
    name: 'description',
    label: 'Deskripsi',
    type: '',
    validation: {},
    col: 12,
    options: [],
    additional: '',
  },
  {
    name: 'is_active',
    label: 'Status',
    type: 'select',
    validation: {},
    col: 12,
    options: [
      {
        name: 'Aktif',
        value: '1',
      },
      {
        name: 'Non-Aktif',
        value: '0',
      },
    ],
    getItemValue: 'name',
    getItemValueId: 'value',
    additional: '',
  },
]

const RolePage: FC = () => {
  let navigate = useNavigate()
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })
  const [isEdit, setIsEdit] = useState(false)
  const [showAssignModuleToRole, setShowAssignModuleToRole] = useState(false)

  const [show, setShow] = useState(false)
  const [query, setQuery] = useState<any>({q: '', sort_order: 'desc'})
  const [formValue, setFormValue] = useState<any>({})
  const [submit, setSubmit] = useState(false)
  const [load, setLoad] = useState(false)
  const [allModule, setAllModule] = useState<any>([])
  const [roleToModule, setRoleToModule] = useState<any>([])
  const [selectedRole, setSelectedRole] = useState<any>('')
  const [data, loading, empty, refresh, isError, setLoading] = useServices(
    MasterServices.getRoleHash,
    {...query, page: pagination.page, sort_field: 'created_at', per_page: pagination.per_page},
    []
  )
  const paginator: any = usePagination({
    totalCount: data?.data?.total,
    pageSize: pagination.per_page || 10,
    currentPage: pagination.page || 1,
  })

  const [dataModule, loadingModule, emptyModule, refreshModule, isErrorModule, setLoadingModule] =
    useServices(
      MasterServices.getModule,
      {...query, page: 1, sort_field: 'created_at', per_page: 1000},
      []
    )

  useEffect(() => {
    refresh()
    generateTotalPage(pagination.total_page)
  }, [pagination.per_page, pagination.page])

  useDebounce(refresh, 250, [query.q, query.sort_order])

  const toggleAssignModuleToRole = (roleId: string = '') => {
    setShowAssignModuleToRole(!showAssignModuleToRole)

    getAllModule()
    if (roleId) {
      getRoleModule(roleId)
    }
    setSelectedRole(roleId ?? '')
  }

  const toggle = () => {
    if (show) {
      setFormValue({})
    }
    setShow(!show)
  }

  const getAllModule = async () => {
    setLoad(true)
    try {
      const module: any = await MasterServices.getModule()
      setAllModule(module.data)
      setLoad(false)
    } catch (error) {
    }
  }

  const getRoleModule = async (id: any) => {
    setLoad(true)
    try {
      const roleModule: any = await MasterServices.getRoleModule({id: id})
      const listed = roleModule.data.modules
      setRoleToModule(listed)
      setLoad(false)
    } catch (error) {
    }
  }

  const generateTotalPage = (totalPage: number) => {
    let total = 0
    let newTotal: any = []

    for (total = 0; total < totalPage; total++) {
      if (total < 4) {
        newTotal.push(total + 1)
      } else if (total === 8) {
        newTotal.push('...')
        newTotal.push(totalPage)
      }
    }
    return newTotal
  }

  const onChangePerPage = (per_page: number, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    })
  }

  const onChange = (e: any) => {
    const {name, value} = e.target
    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const handleDelete = async (id: any) => {
    try {
      if (window.confirm('Yakin ingin men-non aktifkan Role ?')) {
        setLoading(true)
        await MasterServices.deleteRole(id)
        toast.success(`Role Berhasil Di Non-Aktifkan`)
        refresh()
      }
    } catch (error) {
    }
  }

  const onSubmit = async (e: any) => {
    try {
      setSubmit(true)
      e?.preventDefault()
      await (formValue.id ? MasterServices.updateRole : MasterServices.storeRole)(formValue)
      toast.success(`Berhasil ${formValue.id ? 'Memperbarui' : 'Membuat'} Role`)
      toggle()
      refresh()
    } catch (error) {
    } finally {
      setSubmit(false)
    }
  }

  const onSubmitModule = async (e: any) => {
    const formData = new FormData(e.target)
    const formProps = Object.fromEntries(formData)
    let module = Object.keys(formProps).length == 0 ? [] : formProps
    try {
      setSubmit(true)
      e?.preventDefault()
      await MasterServices.updateModule({id: selectedRole, module})
      toast.success(`Berhasil Update Module`)
      toggleAssignModuleToRole()
      refresh()
      setSubmit(false)
    } catch (error) {
      setSubmit(false)
    } finally {
      setSubmit(false)
    }
  }

  const findChecked = (id: any) => {
    return roleToModule.find((object: any) => object.modules_id == id)
  }

  const handleChecked = (id: any) => {
    let module = roleToModule.filter((object: any) => object.modules_id != id)
    setRoleToModule(module)
  }

  return (
    <>
      <div className='row'>
        <Modal show={show} onHide={toggle} size='xl'>
          <Modal.Header closeButton>
            <Modal.Title>{formValue?.id ? 'Edit' : 'Tambah'} Role</Modal.Title>
          </Modal.Header>
          <Form onSubmit={onSubmit}>
            <Modal.Body>
              <Row>{FormGenerator(inputs, formValue, onChange)}</Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant='secondary' onClick={toggle} disabled={submit}>
                Batalkan
              </Button>
              <Button variant='primary' type='submit' disabled={submit}>
                {submit ? 'Loading' : 'Simpan'}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        {/* assign module to role */}
        <Modal show={showAssignModuleToRole} onHide={toggleAssignModuleToRole} size='lg'>
          <Modal.Header closeButton>
            <Modal.Title>Module</Modal.Title>
          </Modal.Header>
          <Form onSubmit={onSubmitModule}>
            <Modal.Body>
              {load
                ? 'Loading...'
                : Object.keys(allModule).map((key, index) => {
                    return (
                      <Fragment key={index}>
                        <div key={`inline-checkbox`} className='mb-8'>
                          {allModule[key]?.map((item: any, i: any) => {
                            return (
                              <div className='row' key={i}>
                                <div className='col-md-6'>
                                  <div className='d-grid gap-2 d-md-flex'>
                                    <input
                                      type='checkbox'
                                      name={item.modules_id}
                                      value={item.modules_id}
                                      checked={findChecked(item.modules_id)}
                                      onChange={() => handleChecked(item.modules_id)}
                                    />
                                    <label>{item.modules_description}</label>
                                  </div>
                                </div>
                              </div>
                            )
                          })}
                        </div>
                      </Fragment>
                    )
                  })}
            </Modal.Body>
            <Modal.Footer>
              <Button
                className='btn btn-sm btn-secondary'
                onClick={() => toggleAssignModuleToRole()}
                disabled={submit}
              >
                Batalkan
              </Button>
              <Button className='btn btn-sm btn-primary' type='submit' disabled={submit}>
                {submit ? 'Loading' : 'Simpan'}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
        {/* end assign module to role */}

        <div className='col-md-12'>
          <div className='card-custom' style={{paddingBottom: '80px'}}>
            <Row>
              <Col md={{span: 4}}>
                <Form.Control
                  placeholder='Cari...'
                  name='q'
                  onChange={(e) => setQuery({...query, q: e.target.value})}
                />
              </Col>
              <Col md={{span: 2, offset: 4}}>
                <Button type='button' onClick={toggle} className='form-control'>
                  {'  '}+ Tambah
                </Button>
              </Col>
              <Col md={{span: 2}}>
                <Form.Select
                  aria-label='Default select example'
                  className='mr-8'
                  onChange={(e) => {
                    setQuery({...query, sort_order: e.target.value})
                  }}
                >
                  <option value='desc'>Terbaru</option>
                  <option value='asc'>Terlama</option>
                </Form.Select>
              </Col>
            </Row>{' '}
            <Row md={12} className='mt-8'>
              <Table responsive className='table-striped align-middle'>
                <thead>
                  <tr>
                    <th>#</th>
                    {heads.map((item, index) => (
                      <th key={index} style={{maxWidth: item.label == 'Aksi' ? '100px' : ''}}>
                        {item.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.data?.data?.length === 0 && !loading && (
                    <tr>
                      <td colSpan={4} align='center'>
                        Tidak ada Data
                      </td>
                    </tr>
                  )}
                  {loading ? (
                    <tr>
                      <td colSpan={4} align='center'>
                        <Spinner
                          animation='border'
                          role='status'
                          style={{height: '100px', width: '100px'}}
                        />
                      </td>
                    </tr>
                  ) : (
                    data.data?.data?.map((item: any, key: any) => {
                      return (
                        <tr key={key}>
                          <td>{key + 1}</td>
                          <td>{item.roles_name}</td>
                          <td>
                            {item.roles_is_active == '0' ? (
                              <Button
                                variant='secondary'
                                className='shadow-none btn-sm btn-sm btn-outline btn-outline-dark'
                              >
                                Non-Aktif
                              </Button>
                            ) : (
                              <Button
                                className='shadow-none btn btn-sm btn-outline btn-outline-success'
                                variant='outline'
                              >
                                Aktif
                              </Button>
                            )}
                          </td>
                          <td>
                            <div className='d-grid gap-2 d-md-flex'>
                              <Button
                                className='btn-sm'
                                disabled={
                                  [
                                    'Auditor',
                                    'Section_Head',
                                    'Super_Admin',
                                    'Alumni',
                                    'Company',
                                  ].filter((f: any) => f === item.roles_name)?.length > 0
                                    ? true
                                    : false
                                }
                                onClick={() => {
                                  setFormValue({
                                    id: item.roles_id,
                                    name: item.roles_name,
                                    description: item.roles_description,
                                    is_active: item.roles_is_active,
                                  })
                                  toggle()
                                }}
                              >
                                Edit
                              </Button>
                              <Button
                                className='btn btn-sm'
                                onClick={() => toggleAssignModuleToRole(item.roles_id)}
                              >
                                Module
                              </Button>
                            </div>
                          </td>
                        </tr>
                      )
                    })
                  )}
                </tbody>
              </Table>
            </Row>
            <Row>
              <Col md={6}>
                {data?.data?.data?.length > 0 && !loading && (
                  <div style={{float: 'left'}}>
                    <Dropdown>
                      <Dropdown.Toggle className='btn btn-sm'>
                        {pagination.per_page}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {[10, 25, 50, 100].map((item: any) => (
                          <Dropdown.Item
                            key={item}
                            href='#/action-1'
                            onClick={() => onChangePerPage(item)}
                            disabled={pagination.per_page === item}
                          >
                            {item}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </Col>
              <Col md={6}>
                <div style={{float: 'right'}}>
                  {!loading && (
                    <Pagination className='btn-sm'>
                      {paginator?.map((item: any) => {
                        return (
                          <Pagination.Item
                            className='btn-sm'
                            key={item}
                            active={item === pagination.page}
                            onClick={() => onChangePerPage(pagination.per_page, item)}
                            disabled={item === '...'}
                          >
                            {item}
                          </Pagination.Item>
                        )
                      })}
                    </Pagination>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  )
}

const Role: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Role Management
      </PageTitle>
      <RolePage />
    </>
  )
}

export default Role
